module.exports = __webpack_public_path__ + "img/yjdd.aeddb427.png";